import { Controller } from 'stimulus'

export default class extends Controller {
  resetHeadingLevels() {
    this.dispatch('resetHeadingLevels', { target: window.parent.document })
  }
}
